function Enum(obj)
{
    const newObj = {};

    for( const prop in obj )
    {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            newObj[prop] = obj[prop];
        }
    }

    return Object.freeze(newObj);
}

export default Enum;